// import { Color } from "@material-ui/lab";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface NotificationState {
  isOpen?: boolean;
//   type?: Color;
  message?: string;
}

export interface ConfirmDialogState {
  isOpen: boolean;
  title?: {};
  subTitle?: {};
  onConfirm?: {};
  item?: any;
}

export interface Loader {
  isLoader?: boolean;
}

const initialState: any = {
  isMenuOpen: true,
  newProperty: true,
  notification: {
    type: "error",
    message: "",
    isOpen: false,
  },

  dialog: {
    title: {},
    subTitle: {},
    onConfirm: {},
    isOpen: false,
    item: null,
  },

  isLoader: false,
};

export const commonReducerSlice = createSlice({
  name: "commonReducer",
  initialState,
  reducers: {
    setIsMenuOpen: (state, action: PayloadAction<boolean>) => {
      return { ...state, isMenuOpen: action.payload };
    },
    showNotification: (state, action: PayloadAction<NotificationState>) => {
      return { ...state, notification: action.payload };
    },
    clearNotification: (state) => {
      return { ...state, notification: false };
    },
    confirmDialogOpen: (state, action: PayloadAction<ConfirmDialogState>) => {
      return { ...state, dialog: action.payload };
    },
    confirmDialogClose: (state) => {
      return { ...state, dialog: false };
    },
    showLoader: (state, action: PayloadAction<Loader>) => {
      return { ...state, isLoader: action.payload };
    },
  },
});

export const {
  setIsMenuOpen,
  showNotification,
  clearNotification,
  confirmDialogOpen,
  confirmDialogClose,
  showLoader,
} = commonReducerSlice.actions;

export default commonReducerSlice.reducer;






